/*----------------------------------
- HOME: HERO DOCK
----------------------------------*/

/**
 * The floating dock at the bottom of the window (docs/mockups/website-home-v3.html `.ps.wp-dock`): two pressed buttons
 * that switch the hero picture between Day station and Night launch. The state lives in `useHomeHero` (HomeStage).
 *
 * @docs docs/features/website-landing-experience
 * @rule The dock switches the picture only; it never changes a figure or a row of the page.
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import { HOME_HERO_DOCK_COPY } from '@/client/catalogs/landing/home/homeCopy';
import type { HomeHero } from './homeScenes';

/*----------------------------------
- TYPES
----------------------------------*/

type HomeHeroDockProps = {
    hero: HomeHero;
    onChange: (hero: HomeHero) => void;
};

/*----------------------------------
- CONSTANTS
----------------------------------*/

/** The dock's order, as drawn: Day station first. */
const HEROES: readonly HomeHero[] = ['day', 'night'];

/*----------------------------------
- COMPONENT
----------------------------------*/

const HomeHeroDock = ({ hero, onChange }: HomeHeroDockProps) => (
    <div class="ps wp-dock" role="group" aria-label={HOME_HERO_DOCK_COPY.label} data-testid="home-hero-dock">
        {HEROES.map((option) => (
            <button
                key={option}
                type="button"
                class={option === hero ? 'on' : undefined}
                aria-pressed={option === hero ? 'true' : 'false'}
                data-hero={option}
                onClick={() => onChange(option)}
            >
                {HOME_HERO_DOCK_COPY[option]}
            </button>
        ))}
    </div>
);

export default HomeHeroDock;
